import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 14, viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.200195 1.86327C0.200195 0.611555 1.57272 -0.155405 2.63875 0.500614L10.9859 5.63731C12.0011 6.26209 12.0011 7.73784 10.9859 8.36262L2.63875 13.4993C1.57272 14.1553 0.200195 13.3884 0.200195 12.1367V1.86327Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
